<ng-container *ngFor="let pivot of pivots">
    <map-marker *ngIf="pivot.ubicacion" [position]="pivot.ubicacion" [icon]="getPivotIcon(pivot)"
        (mapClick)="abrirModal(pivot)">
    </map-marker>
    <map-marker *ngIf="getGpsMarker(pivot)" [position]="getGpsMarker(pivot)" [icon]="getGpsIcon(pivot)"
        (mapClick)="abrirModal(pivot)">
    </map-marker>
    <map-marker *ngFor="let punto of pivot.puntosLlegadaGps" [position]="punto"
        [icon]="getPuntosIcon(punto.numero, pivot)" (mapClick)="abrirModal(pivot)">
    </map-marker>
    <map-polyline *ngIf="mostrarLineaCentroGps && pivot.ubicacion && getGpsMarker(pivot)"
        [path]="[pivot.ubicacion, getGpsMarker(pivot)]" [options]="{
    strokeColor: pivot._id === pivotSeleccionadoId ? '#F72C0D' : '#888888',
    strokeOpacity: 0,
    strokeWeight: 3,
    icons: [{
      icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 4 },
      offset: '0',
      repeat: '15px'
    }]
  }">
    </map-polyline>
</ng-container>

<!-- Modal -->
<div *ngIf="modalAbierto && pivotModal" class="pivot-modal-backdrop" (click)="cerrarModal()">
    <div class="pivot-modal" (click)="$event.stopPropagation()">
        <button class="pivot-modal-close" (click)="cerrarModal()">×</button>
        <h2>{{ pivotModal.nombre }}</h2>
        <div class="pivot-modal-info">
            <div><b>Estado:</b> {{ pivotModal.ultimoEstado | titlecase }}</div>
            <div><b>Fuente de agua:</b> {{ pivotModal.tipoFuenteAgua }}</div>
            <div><b>Presión de trabajo:</b> {{ pivotModal.presionTrabajo }} bar</div>
            <div><b>Caudal:</b> {{ pivotModal.caudal }} m³/h</div>
            <div><b>Última operación:</b> {{ pivotModal.ultimaOperacion?.tipo }} ({{ pivotModal.ultimaOperacion?.fecha |
                date:'short' }})</div>
        </div>
        <div class="pivot-modal-llegadas" *ngIf="pivotModal.puntosLlegadaGps?.length">
            <h3>Puntos de llegada</h3>
            <ul>
                <li *ngFor="let punto of pivotModal.puntosLlegadaGps">
                    <b>Punto {{ punto.numero }}:</b>
                    {{ punto.desc }}
                    <span *ngIf="punto.fecha">({{ punto.fecha | date:'short' }})</span>
                </li>
            </ul>
        </div>
    </div>
</div>